export const sessionTimeoutPopupMinutesDefault = 7
